module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kandidaten":"The candidate","har accepterat inbjudan till jobbet":"has accepted the invitation for the job"},"sv":{"Kandidaten":"Kandidaten","har accepterat inbjudan till jobbet":"har accepterat inbjudan till jobbet"}}')
  delete Component.options._Ctor
}
